import React from 'react';
import { Box, Button, Grid, styled } from '@mui/material';

import { Form, PaginationOrder, Pagination, TypesUtils, useSettings } from 'app/main/components';
import { type ViewTableToolbarProps } from 'app/main/components/page-layouts/view/table/ViewTableComponents';
import ListFilterItem from 'app/main/components/filter/filter-types/ListFilterItem';
import TextFilterItem from 'app/main/components/filter/filter-types/TextFilterItem';

const StyledTextFilterItem = styled(TextFilterItem)(({ theme }) => ({
	'& > .MuiOutlinedInput-root.MuiInputBase-root > .MuiInputBase-input': {
		paddingTop: 9,
		paddingBottom: 9,
		paddingLeft: 12,
		paddingRight: 12
	}
}));

const StyledListFilterItem = styled(ListFilterItem)(({ theme }) => ({
	'& > .MuiTextField-root > .MuiInputBase-root': {
		paddingTop: 3,
		paddingBottom: 3
	}
}));

export default function OrdersLinesAddItemToolbar({
	module,
	paginationProps: {
		filterProps: { currentFilters, handleFilterChange, handleFiltersApply },
		orderProps,
		paginatorProps
	}
}: ViewTableToolbarProps) {
	const { settings, t } = useSettings(module);

	const visibleOrderFilters = settings?.filter_types?.some(filterType => filterType.filt_sortable);

	const [itemsTitleFilter, setItemsTitleFilter] = React.useState(() => {
		const filterValue = currentFilters.find(filt => filt.filt_field === 'item_search')?.filt_value;
		if (TypesUtils.isOneOfTypes(filterValue, ['string', 'number'])) return `${filterValue}`;
		return undefined;
	});

	const [itemsSeriesFilter, setItemsSeriesFilter] = React.useState<string[] | number[] | undefined>(() => {
		const filterValue = currentFilters.find(filt => filt.filt_field === 'item_itsr_id')?.filt_value;
		if (TypesUtils.isArrayOfNumber(filterValue)) return filterValue;
		return undefined;
	});

	return (
		<Box className="p-8" sx={theme => ({ borderBottom: `1px solid ${theme.palette.divider}` })}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={{ md: 'grow', xs: 12 }}>
					<Form id="ordersLinesAddItemToolbarFilters" onSubmit={handleFiltersApply}>
						<Grid container spacing={1}>
							<Grid size={{ md: 3, sm: 6, xs: 12 }}>
								<StyledTextFilterItem
									name="item_search"
									placeholder={t('MODULE_ITEMS_NAME_SINGULAR')}
									operator="like"
									value={itemsTitleFilter}
									sendChange={newValue => {
										handleFilterChange('item_search', 'like', newValue || null);
										setItemsTitleFilter(newValue);
									}}
								/>
							</Grid>
							<Grid size={{ md: 3, sm: 6, xs: 12 }}>
								<StyledListFilterItem
									name="item_itsr_id"
									placeholder={t('DETAILS_ITEMS_FIELD_SERIES')}
									operator="in"
									systable="items_series"
									value={itemsSeriesFilter}
									sendChange={newValue => {
										handleFilterChange('item_itsr_id', 'in', newValue || null);
										setItemsSeriesFilter(newValue);
									}}
								/>
							</Grid>
							<Grid>
								<Button variant="contained" type="submit" form="ordersLinesAddItemToolbarFilters">
									{t('FILTER_BUTTON')}
								</Button>
							</Grid>
						</Grid>
					</Form>
				</Grid>
				<Grid>
					<Grid container justifyContent="flex-end" spacing={1}>
						{visibleOrderFilters && (
							<Grid>
								<PaginationOrder module="items" {...orderProps} />
							</Grid>
						)}
						<Grid>
							<Pagination {...paginatorProps} />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
}
